import { toISOString } from '../../utils/localeHelpers'
import { AdministrativeFormItemDTO, AdministrativeFormTaxDTO } from '../../interface/interface'
import { axiosInstance } from '../../App'
import { creditNotes } from '../../enums/EAdministrativeFormType'
export function getAllOrders(offset: number, pageSize: number, params: any) {
    return axiosInstance.get(`/api/secured/supplier/getAllAdministrativeForms`, {
        params: {
            supplierId: params.supplierId,
            offset,
            pageSize,
        }
    }).then(resp => resp.data)
}

export function getAllOrdersItems(offSet: number, pageSize: number, params: any): Promise<AdministrativeFormItemDTO[]> {
    return axiosInstance.get(`/api/secured/supplier/getAllAdministrativeFormItems`, {
        params: {
            administrativeForm: params.administrativeForm,
            offSet,
            pageSize,
        }
    })
        .then(resp => resp.data)
}

export function getAllOrdersTaxes(offSet: number, pageSize: number, params: any): Promise<AdministrativeFormTaxDTO[]> {
    return axiosInstance.get(`/api/secured/supplier/getAllAdministrativeFormTaxes`, {
        params: {
            administrativeForm: params.administrativeForm,
            isVatTaxes: params.isVatTaxes,
            offSet,
            pageSize,
        }
    }).then(resp => resp.data)
}

function getBodyForOrderOfProvision({ selectedSupplier, reicipt, orderDate, accountDate, expirationDate, pos, voucherNumber, items, netTaxed, noTaxed, exempt, iva, percIva, others, total, payWithCreditCard, operationWithSGR, taxes, description, relatedAdministrativeForm, paidTaxes }: any) {
    return {
        billingEntity: selectedSupplier.medereentity,
        businessname: selectedSupplier.businessname,
        vatcategorydesc: selectedSupplier.vatcategorydesc,
        document: selectedSupplier.document,
        reicipt: reicipt,
        orderDate: orderDate ? toISOString(orderDate) : null,
        accountDate: accountDate ? toISOString(accountDate) : toISOString(orderDate),
        expirationDate: expirationDate ? toISOString(expirationDate) : toISOString(orderDate),
        pos,
        formNumber: voucherNumber,
        items,
        taxes: taxes,
        others: others.toNumber(),
        vatCustomerCategory: selectedSupplier.vatcategory,
        netAmount: netTaxed.toNumber(),
        netAmountNotTaxed: noTaxed.toNumber(),
        exemptAmount: exempt.toNumber(),
        vatAmount: iva.toNumber(),
        taxesAmount: percIva.toNumber(),
        amount: total.toNumber(),
        payWithCreditCard,
        isSGR: operationWithSGR,
        description,
        relatedAdministrativeForm,
        paidTaxes,
    }
}

export function saveOrderOfProvision({ selectedSupplier, reicipt, orderDate, accountDate, expirationDate, pos, voucherNumber, items, netTaxed, noTaxed, exempt, iva, percIva, others, total, payWithCreditCard, operationWithSGR, taxes, description, relatedAdministrativeForm, paidTaxes }: any) {
    const body = getBodyForOrderOfProvision({ selectedSupplier, reicipt, orderDate, accountDate, expirationDate, pos, voucherNumber, items, netTaxed, noTaxed, exempt, iva, percIva, others, total, payWithCreditCard, operationWithSGR, taxes, description, relatedAdministrativeForm, paidTaxes })
    if (creditNotes.includes(reicipt.administrativeformtype)) {
        return axiosInstance.post(`/api/secured/supplier/creditNote`, body, {
        }).then((response) => response.data)
    }
    return axiosInstance.post(`/api/secured/supplier/orderOfProvision`, body, {
    }).then((response) => response.data)
}

export function useOrderOfProvisionService() {
  return {
    getAllOrders,
    getAllOrdersItems,
    getAllOrdersTaxes,
    saveOrderOfProvision,
  }
}
